import { recordEventCustomOnly } from 'utilities/uTagging';
import { TAGGING } from '../constants';

export const doTagProcessAlreadyStartedModal = () => {
    const { COMPONENT, FULL, MODAL, OPEN, PROCESS_ALREADY_STARTED, REQUIREMENTS_TO_BE_CLIENT } = TAGGING;

    recordEventCustomOnly({
        action: OPEN,
        format: MODAL,
        component: COMPONENT,
        element: FULL,
        eventCategory: REQUIREMENTS_TO_BE_CLIENT,
        eventAction: PROCESS_ALREADY_STARTED,
        eventLabel: OPEN,
    });
};

export const doTagCloseProcessAlreadyStartedModal = type => {
    const { CROSS, CLOSE, LINK, COMPONENT, PROCESS_ALREADY_STARTED, REQUIREMENTS_TO_BE_CLIENT } = TAGGING;

    const isCrossOr = alternativeType => (type === CROSS ? CROSS : alternativeType);

    recordEventCustomOnly({
        action: CLOSE,
        format: isCrossOr(LINK),
        component: COMPONENT,
        element: isCrossOr(CLOSE),
        eventCategory: REQUIREMENTS_TO_BE_CLIENT,
        eventAction: PROCESS_ALREADY_STARTED,
        eventLabel: CLOSE,
    });
};
export const doTagProcessRecover = () => {
    const { CLICK, BUTTON, COMPONENT, RECOVER_PROCESS, PROCESS_ALREADY_STARTED, REQUIREMENTS_TO_BE_CLIENT } = TAGGING;

    recordEventCustomOnly({
        action: CLICK,
        format: BUTTON,
        component: COMPONENT,
        element: RECOVER_PROCESS,
        eventCategory: REQUIREMENTS_TO_BE_CLIENT,
        eventAction: PROCESS_ALREADY_STARTED,
        eventLabel: RECOVER_PROCESS,
    });
};
